import { useMemo } from 'react'
import { FlagxsColumnDef } from '../../../../containers/BulkSheetView/gridOptions/extension'
import { TicketRow } from '../../tickets'
import {
  useEstimateColumnGroupDef,
  useEexplanationColumnGroupDef,
  useInformationColumnGroupDef,
  useNameColumnGroupDef,
  getProductivityColumnGroupDef,
  PATH_COLUMN_GROUP_DEF,
  PROGRESS_COLUMN_GROUP_DEF,
  useStoryPointColumnGroupDef,
  CHANGE_LOG_COLUMN_GROUP_DEF,
  useAssignmentColumnGroupDef,
  useTermColumnGroupDef,
  useDefaultColumnGroupDef,
} from './columns'
import { WbsItemSelectColumnOptionType } from '../../../../hooks/useWbsItemSelectColumnOptions'

export type Props = {
  projectUuid: string
  onClickedStatusCell?: (
    target: EventTarget | undefined,
    row: TicketRow | undefined
  ) => void
  onClickedActualHourCell?: (row: TicketRow | undefined) => void
  addRow: (row: TicketRow) => void
  reloadSingleRow: ((uuid: string) => void) | undefined
  submitSingleRow: ((uuid: string) => Promise<boolean | undefined>) | undefined
  context: WbsItemSelectColumnOptionType | undefined
}

export const useColumnDefs = ({
  projectUuid,
  onClickedStatusCell,
  onClickedActualHourCell,
  addRow,
  reloadSingleRow,
  submitSingleRow,
  context,
}: Props): FlagxsColumnDef[] => {
  const defaultColumnGroupDef = useDefaultColumnGroupDef()
  const informationColumnGroupDef = useInformationColumnGroupDef({
    onClickedStatusCell,
    addRow,
  })
  const nameColumnGroupDef = useNameColumnGroupDef({
    reloadSingleRow,
    submitSingleRow,
    context,
  })
  const explanationColumnGroupDef = useEexplanationColumnGroupDef()
  const assignmentColumnGroupDef = useAssignmentColumnGroupDef(
    projectUuid,
    context
  )
  const storyPointColumnGroupDef = useStoryPointColumnGroupDef()
  const estimateColumnGroupDef = useEstimateColumnGroupDef()
  const termColumnGroupDef = useTermColumnGroupDef()
  const columnDefs = useMemo(
    () => [
      defaultColumnGroupDef,
      informationColumnGroupDef,
      PATH_COLUMN_GROUP_DEF,
      nameColumnGroupDef,
      explanationColumnGroupDef,
      assignmentColumnGroupDef,
      storyPointColumnGroupDef,
      estimateColumnGroupDef,
      PROGRESS_COLUMN_GROUP_DEF,
      getProductivityColumnGroupDef(onClickedActualHourCell),
      termColumnGroupDef,
      CHANGE_LOG_COLUMN_GROUP_DEF,
    ],
    [
      onClickedActualHourCell,
      defaultColumnGroupDef,
      informationColumnGroupDef,
      nameColumnGroupDef,
      explanationColumnGroupDef,
      assignmentColumnGroupDef,
      storyPointColumnGroupDef,
      estimateColumnGroupDef,
      termColumnGroupDef,
    ]
  )
  return columnDefs
}
